/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the Equipment interface.
 */
export function instanceOfEquipment(value) {
    if (!("id" in value) || value.id === undefined)
        return false;
    return true;
}
export function EquipmentFromJSON(json) {
    return EquipmentFromJSONTyped(json, false);
}
export function EquipmentFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        id: json.id,
        name: json.name == null ? undefined : json.name,
    };
}
export function EquipmentToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        id: value.id,
        name: value.name,
    };
}
